import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import ScrollToTop from "./views/components/ScrollToTop";

import Participant from "./views/Step10_Participant";
import Program from "./views/Step20_Program";
import Accommodation from "./views/Step30_Accommodation";
import Checkout from "./views/Step40_Checkout";
import Confirmation from "./views/Step50_Confirmation";


// Fallback page
import PageNotFound from "./views/components/PageNotFound";

import "./css/style.css";
import "./css/footer.css";

function App() {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <Routes>
                <Route path="*" element={<PageNotFound />} />
                <Route path="/" element={<Navigate to="/de/participant" replace />} />
                <Route path="/:language/participant" element={<Participant />} />
                <Route path="/:language/program" element={<Program />} />
                <Route path="/:language/accommodation" element={<Accommodation />} />
                <Route path="/:language/checkout" element={<Checkout />} />
                <Route path="/:language/confirmation/:orderId" element={<Confirmation />} />  
            </Routes>
        </BrowserRouter>
    );
}

export default App;
